import { Box, InputBase, useTheme } from "@mui/material"
import { useEffect, useState } from "react";

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { tokens } from "../../../theme";
import SHModal from "../../theme/Modal/SHModal";
import Shbutton from "../../theme/buttons/Shbutton";
import Subheading from "../../theme/text/Subheading";
import Text from "../../theme/text/Text";
import ButtonGroup from "../../theme/buttons/ButtonGroup";
import { useTranslation } from "react-i18next";
import { showToastMessageUpdateRequest, showToastMessageRequestError } from "../../../utils/toasts";
import * as yup from "yup";
import ShValidatedInput from "../../theme/inputs/ShValidatedInput";
import ShValidatedNumberInput from "../../theme/inputs/ShValidatedNumberInput";
import { yupNumberRequired, yupRequired } from "../../../utils/validation";
import { useUpdateStockQuantityMutation } from "../../../newapi/warehouse/stockSlice";
import { useGetInternalReasonsSelectQuery } from "../../../newapi/internalreason/internalReasonSlice";
import ShValidatedInputDropdown from "../../theme/dropdowns/ShValidatedInputDropdown";
import { useCreateSerialNumberMutation } from "../../../newapi/inbound/serialNumberSlice";

const MCreateSerialNumber = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

     const [createSerialNumber,{isLoading}] =  useCreateSerialNumberMutation();


    const [snObject, setSnObject] = useState({
        barcode: "",
    });

    const handleClose = (reload = false) => {
        setSnObject({
            barcode: "",
        });

        props.handleClose(reload);
    }


    const [fieldErrors, setFieldErrors] = useState({});

    const rules = {
        barcode: yupRequired('barcode', t, false),
    };
    
    const schema = yup.object().shape(rules);

    const SaveSerialNumber = async () => {
        try {
            if (isLoading) return;

            // Trim object for update
            const updateObject = {
                "inboundLineId": props.inboundLineId,
                barcode: snObject.barcode,
            }

            setFieldErrors({});
            await schema.validate(updateObject, { abortEarly: false });
            const data = await createSerialNumber(updateObject).unwrap()
            showToastMessageUpdateRequest(t, data);

            handleClose(true);
        } catch (err) {
            if (err.name === 'ValidationError') {
                // Create an errors object where keys are field names and values are error messages
                const errors = err.inner.reduce((acc, currentError) => ({
                  ...acc,
                  [currentError.path]: currentError.message
                }), {});
          
                // Set the validation errors in the state
                setFieldErrors(errors);
              } else {
                // Handle other errors, such as network errors
                showToastMessageRequestError(t("update_failed"), t, err);
              }
        }
    };
    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    const handleChange = (key, value) => {
        setSnObject(prev => ({
          ...prev,
          [key]: value
        }));
        setFieldErrors({
            ...fieldErrors,
            [key]: ''
          });
      };
      
    return(
        <SHModal
            open={props.open}
            onClose={() => handleClose(false)}
        >
            <Box 
                sx={{
                    textAlign:"center",
                    paddingY:4,
                    paddingX:5,
                    display:"flex",
                    flexDirection:"column",
                    alignItems:'center',
                    gap:1
                }}>
                <Subheading>{t("create_serial_number")}</Subheading>
            </Box>
            <Box
                sx={{
                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                    padding:3,
                    borderTopLeftRadius:16,
                    borderTopRightRadius:16,
                    display:"flex",
                    justifyContent:"space-between",
                    gap:2
                }}
            >
                <Box
                    sx={{
                        width:120,
                    }}
                >
                    <Text>{t("barcode")}</Text>
                </Box>
                
                <InputBase
                    onChange={(e) => {
                        handleChange("barcode",e.target.value)
                    }}
                    autoFocus
                    sx={{
                        flex:1,
                        backgroundColor : `${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`,
                        borderRadius:4,
                        display:"flex",
                        height:32,
                        px:2,
                    }}
                />
            
            </Box>
            <Box
                component="footer"
                sx={{
                    
                    display:"block",
                    width:1,
                    paddingBottom: isStandAlone ? "32px" : "16px",
                    display:"flex",
                    alignItems:"center",
                    paddingRight:3,
                    zIndex:1058,
                    position:"relative",
                    paddingTop:2,
                    background:`${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    borderBottomLeftRadius:24,
                    borderBottomRightRadius:24,
                    justifyContent:"space-between",
                    "@media screen and (max-width: 47.9375em)" : {
                        paddingRight:0,
                    }
                }}
            >
                <Shbutton isCancel={true} className={"always-visible"} onClick={() => handleClose(false)} color="primary" variant="text" startIcon={<ArrowRightAltIcon/>}>{t("cancel")}</Shbutton>
                <ButtonGroup version={2}>
                    <Shbutton 
                    isLoading={isLoading} 
                    className={"group-btn"} 
                    color={theme.palette.mode === "dark" ? "blue" : "primary"}
                    variant="contained" 
                    onClick={() => SaveSerialNumber()}
                    >{t("save")}</Shbutton>
                </ButtonGroup>
            </Box>
        </SHModal>
    )
}

export default MCreateSerialNumber;
